function StateItem(data){
    return (
        <p className={`stateItem ${data.addClass ? data.addClass : ""}`} dangerouslySetInnerHTML={{__html:data.text}}/>
    );
}

export {StateItem};